import { render, staticRenderFns } from "./PublisherCampaigns.vue?vue&type=template&id=88dd51a2&scoped=true"
import script from "./PublisherCampaigns.vue?vue&type=script&lang=js"
export * from "./PublisherCampaigns.vue?vue&type=script&lang=js"
import style0 from "./PublisherCampaigns.vue?vue&type=style&index=0&id=88dd51a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dd51a2",
  null
  
)

export default component.exports